export default "__VITE_ASSET__NiSrAgIp__"